import React from 'react'
import {BodyCopy} from '@/components/ui/body-copy'
import {Button} from '@/components/ui/button'
import PropTypes from 'prop-types'
import {enrollmentFetch} from 'hec/builder/helpers/perksAndRewardsHelpers'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useQueryClient} from '@tanstack/react-query'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'

const GoalLevelCopy = ({level, enrollment}) => {
    const {site} = useMultiSite()
    const queryClient = useQueryClient()
    const {data: customerData} = useCurrentCustomer()
    const isRegistered = !!customerData?.isRegistered
    const {complete, loyaltyactionId} = level
    const loyaltyPoints =
        loyaltyactionId &&
        enrollment?.loyaltyData &&
        enrollment.loyaltyData.find((item) => item.actionId === loyaltyactionId).actionPoints

    if (!isRegistered) {
        return (
            <>
                <a href="#login" className="inline" data-testid="moduleAccordion-LoginLink">
                    <Button
                        ctaType="link"
                        variant="secondary"
                        className="underline border-0 bg-transparent inline"
                        data-testid="goalLevelCopy-Button"
                    >
                        Enroll Now
                    </Button>
                </a>
                <BodyCopy size="small" className="inline" data-testid="goalLevelCopy-BodyCopy">
                    {' '}
                    to start earning Perk Points!
                </BodyCopy>
            </>
        )
    }

    return (
        <>
            {!enrollment.isEnrolled ? (
                <>
                    <Button
                        ctaType="link"
                        variant="secondary"
                        onClick={() =>
                            enrollmentFetch(site.id, () =>
                                queryClient.invalidateQueries({
                                    queryKey: ['checkEnrollment', customerData?.email, site.id],
                                    exact: true
                                })
                            )
                        }
                        className="underline border-0 bg-transparent inline"
                        data-testid="goalLevelCopy-Button"
                    >
                        Enroll Now
                    </Button>

                    <BodyCopy size="small" className="inline" data-testid="goalLevelCopy-BodyCopy">
                        {' '}
                        to start earning Perk Points!
                    </BodyCopy>
                </>
            ) : enrollment.isMaxEarned ? (
                <BodyCopy size="small" data-testid="goalLevelCopy-BodyCopy">
                    Yearly earning potential of {enrollment.maxEarned} points achieved!
                </BodyCopy>
            ) : (
                <>
                    {!complete && (
                        <BodyCopy size="small" data-testid="goalLevelCopy-BodyCopy">
                            Potential Earnings: {loyaltyPoints} Points!
                        </BodyCopy>
                    )}
                    {complete && (
                        <BodyCopy size="small" data-testid="goalLevelCopy-BodyCopy">
                            You Earned {loyaltyPoints} Points!
                        </BodyCopy>
                    )}
                </>
            )}
        </>
    )
}

GoalLevelCopy.propTypes = {
    level: PropTypes.object,
    enrollment: PropTypes.object
}

export default GoalLevelCopy
